module.exports = __webpack_public_path__ + "media/images/gallery/6s-b980dbae929451a084f430658e6f4b51.jpg";